<div class="container container-shadow pt-4 pb-5 my-4 mb-4">
  <h4 class="text-center">Preview Newsletter Footer</h4>
  <div class="row">
    <div class="col-md-12">
      <h3>Name:{{ name }}</h3>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <iframe width="100%" height="400px" id="newletter-footer-preview"></iframe>
    </div>
  </div>
</div>
